export var roundIconContainer = function (size) {
    return size
        ? "flex-shrink-0 h-".concat(size.h, "  w-").concat(size.w, " rounded-full flex justify-center items-center ")
        : 'flex-shrink-0 h-12  w-12 rounded-full flex justify-center items-center ';
};
export var roundIconContainerDefault = 'bg-primary text-white';
export var roundIcon = function (size) {
    return size ? "flex-shrink-0 h-".concat(size.h, "  w-").concat(size.w, " ") : 'flex-shrink-0 h-6 w-6 ';
};
//# sourceMappingURL=round-icon.styles.js.map